import React from 'react';
import ProjectQuestionAnswer from "../projectSummery/project-ques-ans";
import './questionAnswerCard.css';

const QuestionAnswer = ({ question_answers, description, roof_scope, pdf }) => {
    const renderDimensionQuestion = (data, index) => {
        if (data.answer === "-") return null;
        const measure = JSON.parse(data.answer).measurements;
        return measure.map((datas, t) => 
            datas && (
                <ProjectQuestionAnswer
                    key={`${index}-${t}`}
                    type="ec-project__question-item--dimension"
                    questionTitle={data.question}
                    DimensionTitle={datas.title}
                    roof_scope
                    widthDimension={datas.measuring_breadth}
                    lengthDimension={datas.measuring_length}
                    heightDimension={datas.measuring_height}
                    unit={datas.unit}
                />
            )
        );
    };

    const renderQuestion = (data, index) => {
        switch (data.question_type) {
            case 7:
                return renderDimensionQuestion(data, index);
            case 4:
                return (
                    <ProjectQuestionAnswer
                        key={index}
                        ProjectQuestion={data.question}
                        ProjectAnswer={data.answer ? "Yes" : "No"}
                        type=""
                    />
                );
            case 6:
                return (
                    <ProjectQuestionAnswer
                        key={index}
                        ProjectQuestion={data.question}
                        ProjectAnswer={Array.isArray(data.answer) ? data.answer.join(", ") : ""}
                        type=""
                    />
                );
            default:
                return (
                    <ProjectQuestionAnswer
                        key={index}
                        ProjectQuestion={data.question}
                        ProjectAnswer={data.answer}
                        type=""
                    />
                );
        }
    };

    const RoofScopeInfo = () => (
        <div className="ec-project__info-roofscope">
            {pdf ? (
                <div className="ec-project__info-inwrap ec-project__info-inwrap--green d-flex p-3">
                    <div className="d-flex">
                        <div className="ec-project__info-icon">
                            <img src="/assets/images/info-file-text.svg" alt="" />
                        </div>
                        <div className="ec-project__info-text">Roofscope data available now.</div>
                    </div>
                    <div className="ec-project__info-action" onClick={() => window.open(pdf, '_blank')}>
                        <span className="ec-project__info-action--text">View Report</span>
                        <span className="ml-1">
                            <img src="/assets/images/info-action.svg" alt="" />
                        </span>
                    </div>
                </div>
            ) : (
                <div className="ec-project__info-inwrap ec-project__info-inwrap--yellow d-flex p-3">
                    <div className="ec-project__info-icon">
                        <span className="ec-project__info-icon--circle">i</span>
                    </div>
                    <div className="ec-project__info-text">
                        Yet to receive dimensions from Roofscope. We will notify you once available.
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <div className="d-flex justify-content-center mb-20 pb-20">
            <div className="ec-project__qa-wrap">
                {roof_scope && <RoofScopeInfo />}
                {question_answers?.length > 0 && question_answers.map((data, i) => renderQuestion(data, i))}
            </div>
        </div>
    );
};

export default QuestionAnswer;